import { render } from "./AiUsageMcp.vue?vue&type=template&id=098c5a9d&scoped=true"
import script from "./AiUsageMcp.vue?vue&type=script&lang=js"
export * from "./AiUsageMcp.vue?vue&type=script&lang=js"

import "./AiUsageMcp.vue?vue&type=style&index=0&id=098c5a9d&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src723/src/github.com/aqfer/cx-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-098c5a9d"]])

export default __exports__